var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "thumbnails" }, [
    _vm.isNavOn
      ? _c(
          "div",
          {
            staticClass: "thumbnails__nav-btn thumbnails__nav-btn--prev",
            on: {
              click: function($event) {
                return _vm.startScroll("up")
              },
              touchend: _vm.stopScroll,
              mouseup: _vm.stopScroll
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "23",
                  height: "23"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    fill: "#A4B1C2",
                    d:
                      "M19.633 19.632A11.425 11.425 0 0111.5 23c-3.072 0-5.96-1.196-8.132-3.368A11.423 11.423 0 010 11.5c0-3.073 1.196-5.961 3.368-8.132A11.425 11.425 0 0111.5 0C17.841 0 23 5.159 23 11.5c0 3.072-1.196 5.961-3.367 8.132zM11.5 2.165c-5.147 0-9.335 4.187-9.335 9.335 0 5.147 4.188 9.335 9.335 9.335 5.148 0 9.335-4.188 9.335-9.335 0-5.148-4.187-9.335-9.335-9.335zm4.229 8.673a1.11 1.11 0 01-.814.366 1.07 1.07 0 01-.699-.261l-1.633-1.397v6.311c0 .607-.476 1.083-1.083 1.083a1.071 1.071 0 01-1.082-1.083V9.546l-1.631 1.395a1.044 1.044 0 01-.705.272 1.07 1.07 0 01-1.069-1.098c0-.338.125-.624.363-.828L11.5 5.731l4.123 3.555c.464.392.513 1.072.112 1.546l-.006.006z"
                  }
                })
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "thumbnails__list" },
      _vm._l(_vm.gallery, function(images, index) {
        return _c(
          "li",
          { key: images.src, staticClass: "thumbnails__item" },
          [
            _c("product-image-cloudfront", {
              staticClass: "product-image__content off_style-b-m",
              attrs: {
                "thumbnail-path": images.thumbnail_path,
                "thumbnail-size": "40",
                alt: _vm._f("htmlDecode")(_vm.productName)
              },
              on: {
                click: function($event) {
                  return _vm.navigate(index)
                }
              }
            })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.isNavOn
      ? _c(
          "div",
          {
            staticClass: "thumbnails__nav-btn thumbnails__nav-btn--next",
            on: {
              click: function($event) {
                return _vm.startScroll("down")
              },
              touchend: _vm.stopScroll,
              mouseup: _vm.stopScroll
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "23",
                  height: "23"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    fill: "#A4B1C2",
                    d:
                      "M11.5 22.999c-3.072 0-5.96-1.196-8.132-3.367A11.425 11.425 0 010 11.5c0-3.073 1.196-5.961 3.368-8.133A11.428 11.428 0 0111.5 0c3.073 0 5.961 1.196 8.133 3.367A11.429 11.429 0 0123 11.5c0 6.341-5.159 11.499-11.5 11.499zm0-20.835c-5.147 0-9.335 4.188-9.335 9.336 0 5.147 4.188 9.335 9.335 9.335 5.148 0 9.335-4.188 9.335-9.335 0-5.148-4.187-9.336-9.335-9.336zm0 15.105l-4.124-3.556a1.054 1.054 0 01-.363-.828c0-.271.087-.518.252-.716.206-.244.503-.383.817-.383.261 0 .512.097.705.273l1.631 1.394V7.142A1.07 1.07 0 0111.5 6.06c.607 0 1.083.475 1.083 1.082v6.311l1.633-1.396a1.07 1.07 0 01.699-.261c.304 0 .601.133.814.365l.006.007c.401.474.352 1.153-.112 1.546L11.5 17.269z"
                  }
                })
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }